<template>
  <div class="md-layout text-center mt-4 login-page-wrapper">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <form @submit.prevent="handleSubmit">
        <login-card class="mb-0">
          <div slot="title" class="image-container logo logoregister mt-4 pt-4">
            <img v-if="site" :src="site.logo" title="" />
          </div>

          <div class="md-field md-form-group" slot="inputs" v-if="!isDemo(false) && !twoFactorStep">
            <span class="login-field-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </span>
            <input class="md-input login-input" v-model="email" type="email" :placeholder="$t('email') + '...'" />
          </div>
          <div
            class="md-field md-form-group password-field-wrapper"
            slot="inputs"
            v-if="!showforgot && subdomain != 'app' && !isDemo(false) && !twoFactorStep"
          >
            <span class="login-field-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </span>
            <input
              class="md-input login-input"
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              :placeholder="$t('password') + '...'"
            />
            <span
              class="password-toggle-icon"
              :title="showPassword ? $t('hidePassword') || 'Ocultar contraseña' : $t('showPassword') || 'Ver contraseña'"
              @click="showPassword = !showPassword"
              role="button"
              tabindex="0"
              @keydown.enter.prevent="showPassword = !showPassword"
            >
              <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </span>
          </div>

          <div class="md-field md-form-group" slot="inputs" v-if="twoFactorStep">
            <p class="two-factor-hint w-100">{{ $t("twoFactor.loginHint") }}</p>
            <span class="login-field-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <line x1="12" y1="18" x2="12.01" y2="18"/>
              </svg>
            </span>
            <input
              ref="twoFactorInput"
              class="md-input login-input"
              v-model="twoFactorCode"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
              :placeholder="$t('twoFactor.codePlaceholder')"
              @keydown.enter.prevent="login"
            />
          </div>

          <div slot="footer">
            <div v-if="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
            <button
              type="button"
              :style="
                'background-color:' + stablishment.primaryColor + ' !important'
              "
              v-if="!showforgot && subdomain != 'app'"
              @click="login"
              class="md-button md-primary md-lg login-submit-btn"
              :disabled="isLoading"
              :aria-busy="isLoading"
            >
              <span
                v-if="isLoading"
                class="d-inline-flex align-items-center gap-2 login-submit-btn__loading"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ $t("Loading") }}
              </span>
              <span v-else-if="isDemo(false)"> {{ $t("seeDemo") }} </span>
              <span v-else> {{ $t("login") }}</span>
            </button>

            <button
              type="button"
              v-if="!showforgot && subdomain == 'app'"
              @click="login"
              class="md-button md-primary md-lg login-submit-btn"
              :disabled="isLoading"
              :aria-busy="isLoading"
            >
              <span
                v-if="isLoading"
                class="d-inline-flex align-items-center gap-2 login-submit-btn__loading"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ $t("Loading") }}
              </span>
              <span v-else>{{ $t("goToMyApp") }}</span>
            </button>
            <p v-if="!showforgot && subdomain == 'app'">
              {{ $t("pleaseinsertemail") }}
            </p>
            <button
              type="button"
              v-if="showforgot"
              @click="sendPassword()"
              class="md-button md-primary md-lg"
              :disabled="!email"
            >
              {{ $t("sendEmail") }}
            </button>
            <div class="my-2" v-if="twoFactorStep">
              <span class="cursor-pointer text-info" @click="cancelTwoFactor">
                {{ $t("twoFactor.backToPassword") }}
              </span>
            </div>
            <div class="my-2" v-else>
              <span
                v-if="!showforgot && !isDemo(false)"
                class="mt-3 cursor-pointer text-info md-simple md-info border-0"
                @click="forgot()"
              >
                {{ $t("forgotPassword") }}
              </span>
              <div
                v-if="!showforgot && site && site.registerEnabled === true"
                class="mt-2"
              >
                <router-link class="gotakeit" :to="{ path: '/register' }">
                  {{ $t("register") }}
                </router-link>
              </div>

              <button
                v-if="showforgot"
                class="text-info md-simple md-info bg-white border-0"
                @click="
                  showforgot = false;
                  errorMessage = '';
                "
              >
                {{ $t("login") }}
              </button>
            </div>
          </div>
        </login-card>
      </form>
    </div>
    
    <!-- Modal de Términos de Servicio -->
    <TermsOfServiceModal
      :show="showTermsModal"
      :termsText="termsText"
      :canClose="false"
      @accepted="onTermsAccepted"
      @close="onTermsAccepted"
      @logout="onLogout"
    />
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import {
  loginAction,
  getMyProfileAction,
  confirmAction,
  sendPassword,
  changePassword,
} from "@/pages/Auth/actions";
import Swal from "sweetalert2";
import permissionsMixin from "@/mixins/permissionsMixin";
import { wencesApi } from "@/api/wencesApi";

// Mock function to replace non-existent import
const getProfileStablishmentsAction = async () => {
  console.warn(
    "getProfileStablishmentsAction is not available - Stablishments actions module was removed"
  );
  return { success: false, data: [] };
};

import TermsOfServiceModal from "@/components/gotrading/common/TermsOfServiceModal.vue";

export default {
  mixins: [permissionsMixin],
  components: {
    LoginCard,
    TermsOfServiceModal,
  },
  data() {
    return {
      email: null,
      password: null,
      showPassword: false,
      logo: "/img/gotakeit.png",
      errorMessage: null, // Añadimos una propiedad para el mensaje de error
      hastoken: false,
      confirm: false,
      subdomain: false,
      showforgot: false,
      stablishment: false,
      allStablishments: [],
      site: false,
      isLoading: false,
      showTermsModal: false,
      termsText: "",
      needsToAcceptTerms: false,
      twoFactorStep: false,
      twoFactorCode: "",
    };
  },
  mounted() {},
  async created() {
    const token = localStorage.getItem("token");
    if (token) {
      // Verificar si necesita aceptar términos
      try {
        const { checkAuthAction } = await import("@/pages/Auth/actions/check-auth.action");
        const statusResp = await checkAuthAction();
        
        if (statusResp.ok && statusResp.needsToAcceptTerms) {
          this.needsToAcceptTerms = true;
          await this.loadTermsText();
          this.showTermsModal = true;
          return; // No redirigir, mostrar el modal
        } else {
          // Si no necesita aceptar términos, redirigir normalmente
          const pendingRoute = localStorage.getItem("pendingRoute");
          if (pendingRoute) {
            localStorage.removeItem("pendingRoute");
            this.$router.push(pendingRoute);
          } else {
            this.$router.push("/dashboard");
          }
          return;
        }
      } catch (error) {
        console.error("Error checking terms:", error);
        // En caso de error, redirigir normalmente
        this.$router.push("/dashboard");
        return;
      }
    }

    const response = await wencesApi.get("/api/settings");

    this.site = response.data.data;

    this.subdomain = window.location.hostname;
    // Usamos split para dividir la URL en partes separadas por "."
    const parts = this.subdomain.split(".");
    // Tomamos la primera parte, que es lo que necesitamos
    this.subdomain = parts[0];

    if (this.$route.query.state) {
      const state = this.$route.query.state;
      const code = this.$route.query.code;
      const newurl =
        "https://" + state + ".app.gotake.it/#/stripe?code=" + code;

      window.location.href = newurl;
      return;
    }
    if (this.$router.currentRoute.params.token) {
      this.hastoken = true;
      const confirmResp = await confirmAction(this.$router.currentRoute.params.token);

      if (confirmResp.ok) {
        this.confirm = true;
        const extra =
          confirmResp.dedicatedAppDbName &&
          ` Su aplicación dedicada quedó en la base «${confirmResp.dedicatedAppDbName}».`;
        Swal.fire({
          title: this.$tn("success"),
          text: (this.$tn("accountconfirm") || "Cuenta confirmada.") + (extra || ""),
          type: "success",
          position: "top",
        });
      } else {
        this.confirm = false;
        Swal.fire({
          title: this.$tn("error") || "Error",
          text: confirmResp.message || "No se pudo confirmar la cuenta.",
          type: "error",
          position: "top",
        });
      }
    }
    if (this.$router.currentRoute.params.login) {
      localStorage.setItem("token", this.$router.currentRoute.params.login);
      localStorage.setItem("name", this.$router.currentRoute.params.name);
      try {
        const { fetchTranslationOverridesFromApiAndPersist } = await import("@/i18n");
        await fetchTranslationOverridesFromApiAndPersist();
      } catch (e) {
        /* sin red o módulo i18n: dashboard con .js base */
      }
      this.$router.push("/dashboard");
      return;
    }
  },
  methods: {
    async forgot() {
      Swal.fire({
        title: this.$tn("forgotPassword"),
        text: this.$tn("passwordResetEmail"),
        type: "question",
        showCancelButton: true,
        confirmButtonText: this.$tn("passwordResetContinue"),
        cancelButtonText: this.$tn("Cancel"),
        position: "top",
      }).then((result) => {
        if (result.isConfirmed) {
          this.showforgot = true;
          this.errorMessage = this.$t("passwordResetEmail");
        } else {
          this.errorMessage = "";
        }
      });
    },
    handleSubmit(event) {
      event.preventDefault();
    },
    async sendPassword() {
      Swal.fire({
        title: this.$tn("emailSent"),
        text: this.$tn("correctEmail", { email: this.email }),
        type: "question",
        showCancelButton: true,
        confirmButtonText: this.$tn("sendEmail"),
        cancelButtonText: this.$tn("Cancel"),
        position: "top",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            sendPassword(this.email);
          } catch (error) {}
          this.showforgot = false;
        } else {
          this.showforgot = false;
          this.errorMessage = "";
        }
      });
    },
    async login() {
      this.isLoading = true;
      this.errorMessage = null;
      try {
        if (this.twoFactorStep && !String(this.twoFactorCode || "").trim()) {
          this.errorMessage = this.$t("twoFactor.codeRequired");
          return;
        }
        const response = await loginAction(
          this.email,
          this.password,
          this.twoFactorStep ? String(this.twoFactorCode).trim() : ""
        );

        if (!response.ok && response.twoFactorRequired) {
          const firstAsk = !this.twoFactorStep;
          this.twoFactorStep = true;
          this.twoFactorCode = "";
          this.errorMessage = firstAsk ? null : response.message || this.$t("twoFactor.invalidCode");
          this.$nextTick(() => this.$refs.twoFactorInput?.focus());
          return;
        }

        if (response.ok) {
          this.errorMessage = null;
          this.twoFactorStep = false;
          this.twoFactorCode = "";
          
          // Verificar si necesita aceptar términos
          if (response.needsToAcceptTerms) {
            this.needsToAcceptTerms = true;
            await this.loadTermsText();
            this.showTermsModal = true;
          } else {
            this.$router.push("/dashboard");
          }
        } else if (response.locked) {
          this.errorMessage = this.$t("loginLocked", { minutes: response.minutesLeft });
        } else {
          const m = response.message;
          if (m && m !== "incorrectUserOrPassword") {
            this.errorMessage = m;
          } else {
            this.errorMessage = this.$t("incorrectUserOrPassword");
          }
        }
      } catch (error) {
        this.errorMessage = this.$t("incorrectUserOrPassword");
      } finally {
        this.isLoading = false;
      }
    },
    cancelTwoFactor() {
      this.twoFactorStep = false;
      this.twoFactorCode = "";
      this.password = null;
      this.errorMessage = null;
    },
    async loadTermsText() {
      try {
        const token = localStorage.getItem("token");
        const response = await wencesApi.get("/api/settings", {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        if (response.data.success && response.data.data) {
          this.termsText = response.data.data.termsOfServiceText || "";
        }
      } catch (error) {
        console.error("Error loading terms:", error);
      }
    },
    onTermsAccepted() {
      this.showTermsModal = false;
      this.needsToAcceptTerms = false;
      
      // Redirigir a la ruta pendiente si existe, o al dashboard
      const pendingRoute = localStorage.getItem("pendingRoute");
      if (pendingRoute) {
        localStorage.removeItem("pendingRoute");
        this.$router.push(pendingRoute);
      } else {
        this.$router.push("/dashboard");
      }
    },
    onLogout() {
      // El modal ya maneja el logout, solo ocultar el modal
      this.showTermsModal = false;
      this.needsToAcceptTerms = false;
    },
  },
};
</script>

<style scoped>
.login-page-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  margin-top: 17px;
  box-shadow: inherit !important;
}

.cursor-pointer {
  cursor: pointer;
}
.image-container {
  max-width: 400px;
}

.error-message {
  color: red;
  margin-top: 10px;
}
.gotakeit {
  font-weight: bold;
  cursor: pointer !important;
  color: var(--bs-primary) !important;
}
.login-page .md-card-login .md-card-header {
  margin-bottom: 0px !important;
}
.login-page .md-card-login {
  background: #ffffff !important;
}
.login-page-wrapper .md-field .login-input {
  padding-left: 10px !important;
}
/* Hover sin focus: mantener fondo oscuro y texto blanco (evitar que se pinte todo blanco) */
.login-page-wrapper .md-field .login-input:hover {

}
/* En focus: texto negro y fondo blanco para que se vea bien */
.login-page-wrapper .md-field .login-input:focus {
  
}
/* Que el focus gane sobre autofill: cuando está enfocado (con o sin autofill), fondo blanco y texto negro */
.login-page-wrapper .md-field .login-input:-webkit-autofill:focus,
.login-page-wrapper .md-field .login-input:-webkit-autofill:active {

}
.login-page-wrapper .md-field .login-input:focus::placeholder {

}
.login-page-wrapper .md-field:focus-within {

}
/* Fondo oscuro solo cuando Chrome autocompleta y NO hay focus */
.login-page-wrapper .md-field .login-input:-webkit-autofill {
 }
/* Hover con autofill: forzar fondo oscuro (más especificidad para que no lo pise otra regla) */
.login-page-wrapper .md-field .login-input.login-input:-webkit-autofill:hover {
 
}

.md-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-submit-btn__loading {
  color: inherit;
}

.login-submit-btn__loading .spinner-border {
  color: inherit;
  vertical-align: middle;
}

.password-field-wrapper {
  position: relative;
}
.login-field-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.password-toggle-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.password-field-wrapper .login-input {
  padding-right: 40px !important;
}


.two-factor-hint {
  margin-bottom: 8px;
  text-align: left;
}

.logoregister {
  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 200px;
}
</style>
